module.exports = __webpack_public_path__ + "img/Electricite_de_provence_80X30.71aa763d.png";